import { defaultAuthenticatedPath } from '@constants/auth.constant';

const authFlowPaths = ['/login', '/redirecting', '/unauthorized'];

/**
 * Accepts only same-origin app paths so a crafted `redirect` cannot send a
 * freshly signed-in user to another site or back into the auth flow.
 */
export function resolvePostSignInRedirect(redirect?: string | null): string {
  // Browsers drop tabs/newlines while parsing, turning "/\t/x" into "//x".
  // eslint-disable-next-line no-control-regex
  if (!redirect?.startsWith('/') || /[\u0000-\u001f\\]/.test(redirect)) {
    return defaultAuthenticatedPath;
  }

  const { origin } = globalThis.location;
  const url = new URL(redirect, origin);

  if (url.origin !== origin || authFlowPaths.includes(url.pathname)) {
    return defaultAuthenticatedPath;
  }

  return `${url.pathname}${url.search}${url.hash}`;
}
